import { Container, Stack, Text, Title } from "@mantine/core";

const TERMS_OF_SALE_ARTICLES: { title: string; paragraphs: string[] }[] = [
  {
    title:
      "Article 1. Opposabilité des Conditions générales de vente de laboratoire Jasper",
    paragraphs: [
      "En passant commande auprès de Jasper, notamment par l’envoi d’empreinte dentaire numérique, accompagnée le cas échéant d’un bon de commande ou d’une prescription, le Licencié reconnaît avoir préalablement pris connaissance des présentes conditions générales et les avoir acceptées sans restriction.",
    ],
  },
  {
    title: "Article 2. Commande",
    paragraphs: [
      "Toute commande, même non rédigée sur un bon de commande du progiciel ou de l’application Jasper, est soumise aux présentes conditions générales et ouvre droit à facturation des travaux confiés.",
      "Toute commande est passée et ne peut donner lieu à annulation totale ou partielle que si elle intervient dans les douze (12) heures suivant sa réception au siège de la Société.",
      "La Société n’est responsable ni du remplissage du bon de commande ni de la qualité des empreintes et des modèles envoyés par le Licencié qui ont une incidence sur la parfaite adaptation en bouche.",
      "En cohérence avec les usages de la Profession, la Société se réserve la possibilité d’ajouter, lors d’identification de problématiques techniques en production, des éléments non expressément commandés par le Licencié tels que crochet(s), clavette(s), contreplaque(s), dent(s) pleine(s), etc.",
      "Toute commande livrée sera considérée comme acceptée si elle ne fait pas l’objet d’une réclamation écrite dans les trois (3) jours suivant la livraison.",
    ],
  },
  {
    title: "Article 3. Métaux précieux",
    paragraphs: [
      "3.1. Dans le cas de travaux sur métaux précieux ou semi-précieux, le taux de perte appliqué lors de la coulée et du grattage sera de 25 % (taux pratiqué par l’ensemble de la profession).",
      "3.2. Dans le cas de travaux refaits, après récupération du travail initial, Jasper se réserve la possibilité de facturer les nouvelles pertes occasionnées.",
    ],
  },
  {
    title:
      "Article 4. Prix, facturation et conditions de règlement des commandes de prothèses",
    paragraphs: [
      "4.1. Les prix applicables, dont le Licencié reconnaît avoir été préalablement informé, sont ceux en vigueur au jour de la commande passée.",
      "4.2. Une facture récapitulative des bons de livraison est éditée chaque début de mois pour le mois précédent et est payable à réception, sous un délai de 15 jours.",
    ],
  },
  {
    title: "Article 5. Garantie",
    paragraphs: [
      "5.1. Les travaux réalisés sont garantis, à compter de leur livraison, pour une durée de trois (3) ans.",
      "5.2. Le délai de garantie court à compter de la livraison du travail initial. Les travaux refaits dans le cadre de la garantie ne font pas courir de nouveau délai de garantie.",
      "5.3. Tout retour à la Société de travaux à modifier ou à refaire devra comprendre l’intégralité des travaux préalablement effectués (modèles en plâtre haut et bas d’origine, prothèses, etc.) avec le numéro de la commande d’origine. Dans le cas contraire, Jasper facturera au Licencié l’ensemble des travaux nouvellement réalisés.",
      "5.4. Toute modification de préparation des dents par rapport au modèle initial, tout changement par rapport à la prescription initiale (nature du travail, teinte, etc.) entraînera une nouvelle facturation des prothèses réalisées.",
      "5.5. Aucune garantie ne s’appliquera sur les travaux prothétiques non posés en bouche passé un délai d’un (1) mois après leur livraison.",
      "5.6. En cas de contraintes techniques liées à l’empreinte ou à la prescription, Jasper se réserve le droit de ne pas garantir les travaux confiés et en avise le Licencié préalablement à leur réalisation.",
    ],
  },
  {
    title: "Article 6. Délais",
    paragraphs: [
      "6.1. Les délais d’exécution et de livraison des travaux sont donnés au Licencié à titre indicatif. La responsabilité de Jasper ne peut être engagée, notamment dans les cas suivants : retard de livraison imputable au transporteur, à des événements fortuits (accident, grève, etc.) ou à des cas de force majeure (intempéries, incendie, catastrophe naturelle, etc.) ; retard de livraison imputable à des difficultés techniques de réalisation des prothèses inhérentes à la fabrication artisanale des Dispositifs Médicaux Sur Mesure.",
      "6.2. Tout dépassement de ces délais ne pourra donner lieu ni au versement de dommages et intérêts, ni à réduction du prix, ni à la résiliation de la commande.",
    ],
  },
  {
    title: "Article 7. Litiges",
    paragraphs: [
      "Pour tout litige susceptible de s’élever entre les parties quant à la formation, l’exécution ou l’interprétation de tout ou partie du présent contrat, les parties conviennent expressément que seront seules compétentes les Juridictions de Paris. Le droit applicable est le droit français, quelle que soit la nationalité du Licencié.",
    ],
  },
];

export const TermsOfSalePage = () => {
  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title order={1}>
          Conditions générales de vente, de passation des commandes, de
          livraison et de règlement
        </Title>
        {TERMS_OF_SALE_ARTICLES.map(article => (
          <Stack key={article.title} gap="xs">
            <Title order={3}>{article.title}</Title>
            {article.paragraphs.map((paragraph, index) => (
              <Text key={index}>{paragraph}</Text>
            ))}
          </Stack>
        ))}
      </Stack>
    </Container>
  );
};
